import styled from 'styled-components';
import animPulse from '../../../helpers/animPulse';
import { gradient } from '../../../helpers/styleUtils';

const ResultIconStyled = styled.svg`
  ${gradient.background(
    `45deg`,
    props => props.theme.colors.orange,
    props => props.theme.colors.red
  )};
  animation: ${props => (props.win ? `${animPulse} 0.5s infinite` : `none`)};
  background: ${props => (props.win ? props.theme.colors.yellow : '')};
  border-radius: 100%;
  box-shadow: 0 0 0 10px rgba(0, 0, 0, 0.05);
  fill: ${props =>
    props.win ? props.theme.colors.dark : props.theme.colors.white};
  height: 30px;
  left: 50%;
  padding: 15px;
  position: absolute;
  top: 0;
  transform: translate(-50%, -50%);
  width: 30px;
`;

export default ResultIconStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/ResultIcon/ResultIcon.styled.js